import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth, isSuperAdmin } from "../contexts/AuthContext";
import ThemeToggle from "./ThemeToggle";

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar-inner">
          <span className="brand">QR Tracker</span>
          <nav>
            <NavLink to="/qrs">QR Kodlar</NavLink>
            {isSuperAdmin(user) && <NavLink to="/users">Kullanıcılar</NavLink>}
          </nav>
          <div className="topbar-user">
            <ThemeToggle />
            <span>{user?.name || user?.email}</span>
            <button className="btn btn-ghost" onClick={handleLogout}>
              Çıkış
            </button>
          </div>
        </div>
      </header>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
